const OneOffBookingsWrapper = ({ children }) => children

OneOffBookingsWrapper.authParams = { allowFinanceF3: true }

export default OneOffBookingsWrapper
